// extracted by mini-css-extract-plugin
export default {"TitleDialogContent":"ModalGlobal_TitleDialogContent__9+Wy+","TitleDialogTexto":"ModalGlobal_TitleDialogTexto__N2XZe"};